import { Component, OnInit, Input, OnChanges, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ZGeneral } from './z-general';

@Component({
  selector: 'lib-z-button',
  templateUrl: './z-button.html',
  styleUrls: ['./z-button.css']
})
export class ZButton extends ZGeneral implements OnInit, OnChanges, OnDestroy {

  compName: string = 'button';

  element:any;

  @Input() actionInProgress ?: Boolean;

  @Input() appearance ?: String;

  @Input() disabled ?: Boolean;

  @Input() icon ?: String;

  @Input() iconClass ?: String;

  @Input() iconClassName ?: String;

  @Input() progressIndicator ?: Object;

  @Input() size ?: String;

  @Input() SVGIconId ?: String;

  @Input() text ?: String;

  opts = [  'actionInProgress',  'appearance',  'disabled',  'icon',  'iconClass',  'iconClassName',  'progressIndicator',  'size',  'SVGIconId',  'text'  ];

  events = ["click"];

  @Output() zclick ?: EventEmitter<any> = new EventEmitter();

}
